// import Login from './Components/Header/Login';
import Routes from './routes';
import './App.scss';
import './App.css';

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
